import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

// import styles from './style.module.scss'
import Layout from '@shared/components/layout'
import { allRoutes } from '@shared-submodule/sm-constants/allRoutes'
import { WIDGET } from '@shared-submodule/sm-constants'
import CurrentSeries from '../widgets/currentSeries'
import AllWidget from '@shared/components/allWidget'
// import StaticBannerSecond from '../StaticBannerSecond'
import StaticBanner from '../staticBanner'
// import { googleAddData } from '@shared-submodule/sm-constants/googleAdsData'
// import { skyAddData } from '@shared/constants/skyAds'
import useWindowSize from '@shared/hooks/windowSize'
import { reviveAdData } from '@shared/components/reviveAds/reviveAdData'

const ReviveAds = dynamic(() => import('@shared/components/reviveAds'), { ssr: false })
// const GoogleAds = dynamic(() => import('@shared-submodule/sm-components/googleAds'), { ssr: false })
const Skeleton = dynamic(() => import('@shared/components/skeleton'), { ssr: false })
const LazyLoad = dynamic(() => import('@shared/components/lazyLoad'), { ssr: false })
const CommonNav = dynamic(() => import('@shared/components/commonNav'), {
  loading: () => (
    <div className="bg-white p-2 d-flex rounded-pill">
      <Skeleton className={'mx-1'} />
      <Skeleton className={'mx-1'} />
      <Skeleton className={'mx-1'} />
      <Skeleton className={'mx-1'} />
    </div>
  )
})
const ATSAds = dynamic(() => import('@shared/components/atsAds'), { ssr: false })

export default function FixtureContent({ children, type, seoData, currentSeriesData }) {
  const [width] = useWindowSize()
  const headingText = {
    currentMatches: 'Live Cricket Score',
    scheduleByMonth: 'Cricket Schedule',
    currentSeries: 'Current and Upcoming Series',
    seriesArchive: 'Cricket Series Archive'
  }

  const navData = [
    { navItem: 'Current Matches', url: allRoutes.fixturesNew, active: type === 'currentMatches' && true },
    { navItem: 'Schedule By Month', url: allRoutes.cricketSchedule, active: type === 'scheduleByMonth' && true },
    {
      navItem: 'Current and future series',
      url: allRoutes.cricketSeriesNew,
      active: type === 'currentSeries' && true
    },
    { navItem: 'Series Archive', url: allRoutes.cricketSeriesArchive, active: type === 'seriesArchive' && true }
  ]

  const { addTop, addBottom, addRight, addLeft, mobSm, add300 } = reviveAdData
  const randomAd = Math.random() < 0.5 ? addLeft : add300

  return (
    <Layout data={{ oSeo: seoData }}>
      <section className="common-section pt-4">
        <ATSAds />
        <Container>
          <Row>
            <Col lg={9} className="left-content">
              <h1 className="mb-2">{headingText[type] || type}</h1>
              <div className="w-full d-xl-flex d-none justify-content-center ">
                {/* <GoogleAds
                  addId={googleAddData?.addTop?.addId}
                  divId={googleAddData?.addTop?.divId}
                  dimension={googleAddData?.addTop?.dimension}
                  slotId={googleAddData?.addTop?.slotId}
                  className={'mb-0 mt-0'}
                /> */}
                <ReviveAds {...addTop} className={'mb-0 mt-0'} />
              </div>
              <div className="w-full d-xl-none d-flex justify-content-center ">
                {/* <GoogleAds
                  addId={googleAddData?.mobSm?.addId}
                  divId={googleAddData?.mobSm?.divId}
                  dimension={googleAddData?.mobSm?.dimension}
                  slotId={googleAddData?.mobSm?.slotId}
                /> */}
                <ReviveAds {...mobSm} className={'mb-0 mt-0'} />
              </div>
              <CommonNav style={{ margin: '0 !important' }} items={navData} />
              {children}
              {width > 1400 && (
                // <GoogleAds
                //   addId={skyAddData?.addBottom?.addId}
                //   divId={skyAddData?.addBottom?.divId}
                //   dimension={skyAddData?.addBottom?.dimension}
                //   slotId={skyAddData?.addBottom?.slotId}
                //   className={'my-3'}
                // />
                <ReviveAds {...addBottom} className={'my-3 text-center'} />
              )}
              {width < 1000 && (
                // <GoogleAds
                //   addId={skyAddData?.addRight?.addId}
                //   divId={skyAddData?.addRight?.divId}
                //   dimension={skyAddData?.addRight?.dimension}
                //   slotId={skyAddData?.addRight?.slotId}
                //   className={'my-3'}
                // />
                <ReviveAds {...addRight} className={'d-flex justify-content-center my-3'} />
              )}
            </Col>
            <Col lg={3} className="common-sidebar isDesk">
              <AllWidget type={WIDGET.trendingNews} show />
              <ATSAds />
              {/* <StaticBannerSecond adType="secondAd_Rect" link="live_score_right_banner" /> */}
              <LazyLoad>
                {/* <GoogleAds
                  addId={googleAddData?.addLeft?.addId}
                  divId={googleAddData?.addLeft?.divId}
                  dimension={googleAddData?.addLeft?.dimension}
                  slotId={googleAddData?.addLeft?.slotId}
                  className={'mb-4'}
                /> */}
                <ReviveAds {...addLeft} className={'mb-4'} />
                <CurrentSeries dataSSR={currentSeriesData} />
                <ReviveAds {...add300} className={'mb-4'} />
                <AllWidget type={WIDGET.topTeams} show />

                <StaticBanner isLeft />
              </LazyLoad>
            </Col>
            {/* <div className="d-md-none">
              <StaticBannerSecond adType="secondAdRect_Left" link="live_score_mweb_right_banner" />
            </div> */}
            <div className="d-md-none">
              <StaticBanner isLeft />
            </div>
            <div className="w-full d-lg-none d-flex  justify-content-center mb-3">
              <ReviveAds {...randomAd} />
            </div>
          </Row>
        </Container>
      </section>
    </Layout>
  )
}

FixtureContent.propTypes = {
  type: PropTypes.string,
  children: PropTypes.node,
  seoData: PropTypes.object,
  currentSeriesData: PropTypes.object
}
